export class Controller {

    /** @ngInject */
    constructor($state, Alert, DirectoriesResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
        this.name = '';
    }

    save() {
        this.isSaving = true;
        this.DirectoriesResource
            .createActiveDirectory(this.companyId, this.name)
            .then((directory) => {
                this.directories.push(directory);
                this.Alert('success', 'company.directory-integration.add-active-directory.added');
                return this.$state.go('company.directory-integration.manage.domains', {directoryId: directory.id});
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/add/add-active-directory.controller.js